import './Logo.css';

// Vendors
import React, {Component} from 'react';
import {CSSTransition} from 'react-transition-group';
import STATUS from '../Game/constants';
import classnames from 'classnames';

// Assets
import greenLight from './svg/GreenLightText.svg';
import redLight from './svg/RedLightText.svg';

export default class Logo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redLight: true,
      greenLight: false,
      fadeInLogo: false,
      fadeInButton: false,
    }
  }

  onAnimationEnd(event) {
    if (event.animationName === 'scaleUpLeft') {
      this.setState({
        greenLight: true,
      })
    }

    if (event.animationName === 'scaleUpRight') {
      this.setState({
        fadeInLogo: true,
      })
    }

    if (event.animationName === 'fadeIn') {
      if (event.currentTarget.nodeName === 'IMG') {
        this.setState({
          fadeInButton: true
        })
      }
    }
  }

  render() {
    const greenClass = classnames(
      'greenBubble',
      {'scaleUpRight' : this.state.greenLight}
    )
    const redClass = classnames(
      'redBubble',
      {'scaleUpLeft' : this.state.redLight}
    )

    const fadeRedText = this.state.greenLight ? 'fadeIn' : '';
    const fadeGreenText = this.state.fadeInLogo ? 'fadeIn' : '';

    const contentContainerClass = classnames(
      'contentContainer',
      {'visible' : this.state.fadeInButton}
    )

    return (
      <CSSTransition
        in={this.props.status === STATUS.LOGO}
        timeout={350}
        classNames="fade"
        unmountOnExit
      >
        <div className="Logo">
          <div className="container">
            <div className={redClass} onAnimationEnd={this.onAnimationEnd.bind(this)}>
              <div className="container__text">
                <img className={fadeRedText} src={redLight} alt="Red Light"/>
              </div>
            </div>
            <div className={greenClass} onAnimationEnd={this.onAnimationEnd.bind(this)}>
              <div className="container__text">
                <img className={fadeGreenText} src={greenLight} alt="Green Light" onAnimationEnd={this.onAnimationEnd.bind(this)}/>
              </div>
            </div>
          </div>

          <div className={classnames(contentContainerClass, 'content')}>
            <p>Swipe the cards left or right to identify which gambling habits are positive and which you should avoid.</p>
          </div>

          <div className="Logo__ctas">
            <div className={contentContainerClass}>
              <button className="button" onClick={this.props.startGame}>Play game</button>
            </div>
            <div className={contentContainerClass}>
              <button className="button" onClick={this.props.playIntro}>Watch tutorial</button>
            </div>
          </div>
        </div>
      </CSSTransition>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Logo/Logo.js